import { useConsumeFlashCookiePath } from "@impero-com/common/utils/flash";
import { Navigate } from "react-router-dom";

import { HomeRedirect } from "./homeRedirect";

export function PostLoginRedirect() {
    const flashRedirectPath = useConsumeFlashCookiePath();
    return flashRedirectPath !== null ? (
        <Navigate to={flashRedirectPath} replace />
    ) : (
        <HomeRedirect />
    );
}
